import React from "react";

interface Props {
  label: string;
  children: React.ReactNode;
}

// Dark pill tooltip above the child element. CSS group-hover driven so no JS
// state and no event handlers needed. Pointer events none so hover stays on
// the real target.
export default function Tooltip({ label, children }: Props) {
  return (
    <span className="group relative inline-flex">
      {children}
      <span className="pointer-events-none absolute bottom-full left-1/2 -translate-x-1/2 mb-1.5 bg-ink text-white text-[11px] font-semibold px-2 py-1 rounded whitespace-nowrap opacity-0 group-hover:opacity-100 transition-opacity z-50">
        {label}
      </span>
    </span>
  );
}